import { Components, Theme } from '@mui/material/styles';

export default function Tabs({ palette, typography }: Theme): Components {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          color: palette.text.primary,
          fontWeight: typography.fontWeightRegular,
          '&.Mui-selected': {
            backgroundColor:
              palette.mode === 'dark' ? palette.background.paper : palette.primary.contrastText,
            fontWeight: typography.fontWeightBold,
          },
        },
      },
    },
  };
}
